import { endOfMonth, format, startOfMonth } from 'date-fns';
import type { Period } from 'components/shared/DateNavigation';
import { toNativeDate } from 'utils/date';

interface UseDateRangeCalculationInput {
  period: Period;
  selectedDate: Date | null;
  selectedDateRange: [Date | null, Date | null];
}

export interface UseDateRangeCalculationOutput {
  isCustomRange: boolean;
  customStartDate: Date | null;
  customEndDate: Date | null;
  hasCompleteCustomRange: boolean;
  startDateValue: Date | null;
  endDateValue: Date | null;
  startDate: string;
  endDate: string;
}

export const useDateRangeCalculation = ({
  period,
  selectedDate,
  selectedDateRange
}: UseDateRangeCalculationInput): UseDateRangeCalculationOutput => {
  'use memo';

  const isCustomRange = period === 'custom';
  const customStartDate = toNativeDate(selectedDateRange?.[0]);
  const customEndDate = toNativeDate(selectedDateRange?.[1]);
  const hasCompleteCustomRange = !!customStartDate && !!customEndDate;

  let startDateValue: Date | null = null;
  let endDateValue: Date | null = null;

  if (isCustomRange) {
    startDateValue = customStartDate;
    endDateValue = customEndDate;
  } else if (selectedDate) {
    startDateValue = startOfMonth(selectedDate);
    endDateValue = endOfMonth(selectedDate);
  }

  const startDate = startDateValue ? format(startDateValue, 'yyyy-MM-dd') : '';
  const endDate = endDateValue ? format(endDateValue, 'yyyy-MM-dd') : '';

  return {
    isCustomRange,
    customStartDate,
    customEndDate,
    hasCompleteCustomRange,
    startDateValue,
    endDateValue,
    startDate,
    endDate
  };
};
